/**
 * Application Constants
 * App-wide constants including transitions, z-index scale, and other values.
 */

/**
 * Animation and transition durations
 */
export const transitions = {
  fast: '150ms',
  normal: '300ms',
  slow: '500ms',

  // Easing functions
  easing: {
    easeIn: 'cubic-bezier(0.4, 0, 1, 1)',
    easeOut: 'cubic-bezier(0, 0, 0.2, 1)',
    easeInOut: 'cubic-bezier(0.4, 0, 0.2, 1)',
  },
} as const;

/**
 * Z-index scale for layering components
 */
export const zIndex = {
  base: 0,
  dropdown: 1000,
  sticky: 1020,
  fixed: 1030,
  modalBackdrop: 1040,
  modal: 1050,
  popover: 1060,
  tooltip: 1070,
} as const;

/**
 * App-specific constants
 */
export const app = {
  name: 'The Home CEO',
  maxContentWidth: '1120px',
  headerHeight: '64px',
  footerHeight: '80px',
} as const;
